var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_475_69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 38,
    r: 34,
    transform: "rotate(90 46 38)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 38,
    r: 33,
    transform: "rotate(90 46 38)",
    stroke: "url(#paint0_linear_475_69)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8457 42.5558L46.2932 36.6636L52.7407 42.5558C53.3888 43.1481 54.4357 43.1481 55.0838 42.5558C55.7318 41.9636 55.7318 41.0068 55.0838 40.4146L47.4564 33.4442C46.8084 32.8519 45.7615 32.8519 45.1134 33.4442L37.4861 40.4146C36.838 41.0068 36.838 41.9636 37.4861 42.5558C38.1341 43.1329 39.1976 43.1481 39.8457 42.5558Z",
    fill: "#0F0E96"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_475_69",
    x: 0.3,
    y: 0.3,
    width: 91.4,
    height: 91.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_475_69",
    x1: 80,
    y1: 38,
    x2: 12,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUpgrade);
export default __webpack_public_path__ + "static/media/scrollUpgrade.7eca92922e4a87d138da75c6a571c234.svg";
export { ForwardRef as ReactComponent };